import React from 'react';

type TProps = {
  children: JsxNode;
  display: boolean;
};
export default function Display({ children, display }: TProps) {
  if (!display) {
    return null;
  }
  return <>{children}</>;
}
